import axios from 'axios';
import ls from 'local-storage';

import { API_ENDPOINT } from './constants';

const TrackingAPI = {
  async sendTrackEventRequest(eventName, data = {}) {
    try {
      const pld = (
        await axios.post(`${API_ENDPOINT}/tracking/track-frontend-event`, {
          eventName: eventName,
          data: data
        })
      ).data;
      return pld;
    } catch (exc) {}
  },

  trackEvent(eventName, data = {}) {
    const eventsToTrack = ls.get('eventsToTrack') || [];

    let currentReferrer;
    let currentUrl;
    try {
      currentReferrer = document.referrer;
      currentUrl = window.location.href;
    } catch (exc) {}
    const newEvent = {
      t: +new Date(),
      id: `event-${+new Date()}-${Math.random()}`,
      eventName: `frontend_${eventName}`,
      data: {
        isFrontend: true,
        current_referrer: currentReferrer,
        current_url: currentUrl,
        ...data
      }
    };
    eventsToTrack.push(newEvent);
    ls.set('eventsToTrack', eventsToTrack);
  },

  async runInfiniteTracking() {
    try {
      while (true) {
        await delay(2000);
        try {
          const eventsToTrack = ls.get('eventsToTrack') || [];
          if (eventsToTrack.length == 0) {
            continue;
          }
          const eventsToTrackCopy = [...eventsToTrack];
          ls.set('eventsToTrack', []);
          for (const i in eventsToTrackCopy) {
            const event = eventsToTrackCopy[i];
            try {
              await this.sendTrackEventRequest(event.eventName, event.data);
            } catch (exc) {}
          }
        } catch (exc1) {}
      }
    } catch (exc0) {}
  }
};

function delay(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
}

export default TrackingAPI;
